import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthenticationService } from "../services/authentication/authentication.service";
import { ObjectUtils } from "../utils/object-utils";

@Injectable({
    providedIn: "root"
})
export class CanEditResolver  {
    private readonly authenticationService = inject(AuthenticationService);

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
        const { editRoles } = route.data;
        if(ObjectUtils.isNullOrUndefined(editRoles)) {
            return of(false);
        }

        const isInRole = this.authenticationService.hasAnyRole(editRoles);
        return of(isInRole);
    }
}
